<script setup lang="ts">
import { useThrottleFn } from '@vueuse/core'
import { useLanguage } from '@/core/composables/useLanguage'
import Button from '@/core/components/base/Button.vue'

// Example:
// <language-switcher />
// <language-switcher class="top-right">
//   <template #th><img src="/images/lang-th.png" /></template>
//   <template #en><img src="/images/lang-en.png" /></template>
// </language-switcher>

const { currentLang, availableLocales, switchLanguage } = useLanguage()

const handleTap = useThrottleFn((event: PointerEvent) => {
  switchLanguage()
}, 200)
</script>

<template>
  <Button class="language-switcher" @tap="handleTap($event)">
    <template v-for="lang in availableLocales">
      <transition name="fade" mode="out-in">
        <div v-show="lang == currentLang" class="icon-lang" :lang="lang">
          <slot :name="lang">
            <h2>{{ lang }}</h2>
          </slot>
        </div>
      </transition>
    </template>
  </Button>
</template>

<style scoped>
.language-switcher {
  width: 99px;
  height: 59px;
  user-select: none;
}

.language-switcher.top-right {
  position: absolute;
  top: 25px;
  right: 28px;
}

.icon-lang {
  position: absolute;
  cursor: pointer;
}

.icon-lang h2 {
  padding: 5px 10px;
}
</style>
